import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  Input,
  PLATFORM_ID,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { Sidebar, SidebarModule } from 'primeng/sidebar';

/**
 * !NOTE: Before rename it search references
 */
@Component({
  selector: 'lib-shared-feature-sidemenu',
  standalone: true,
  imports: [CommonModule, SidebarModule, FontAwesomeModule],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './shared-feature-sidemenu.component.html',
  styleUrl: './shared-feature-sidemenu.component.scss'
})
export class SharedFeatureSidemenuComponent implements AfterViewInit {
  private readonly elementRef = inject(ElementRef<HTMLElement>);
  readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  @ViewChild('sidemenu') sidemenu!: Sidebar;
  @ViewChild('sidemenu', { read: ElementRef }) sidemenuHTML!: ElementRef<HTMLElement>;
  @ViewChild('overlay', { read: ElementRef }) overlay!: ElementRef<HTMLElement>;

  @Input() appendTo?: HTMLElement;

  @Input() linkClass = '';

  @Input() overlayZIndex = 5;

  @Input() closeIconFontSize?: string;

  @Input() closeIconColor?: string;

  _sidebarVisible = false;
  get sidebarVisible(): boolean {
    return this._sidebarVisible;
  }
  set sidebarVisible(val: boolean) {
    const overlay = this.overlay.nativeElement;
    this._sidebarVisible = val;

    if (val) {
      overlay.style.display = 'block';
    } else {
      overlay.style.display = 'none';
      this.sidemenu?.destroyModal();
    }
  }

  readonly faMenu = faBars;

  ngAfterViewInit(): void {
    if (!this.isBrowser) {
      return;
    }
    this.setCloseStyling();
    this.setSideOverlayElement();
  }

  setCloseStyling() {
    const el = this.sidemenuHTML.nativeElement;
    if (this.closeIconFontSize) el.style.setProperty('--close-icon__fontSize', this.closeIconFontSize);
    if (this.closeIconColor) el.style.setProperty('--close-icon__color', this.closeIconColor);
  }

  setSideOverlayElement() {
    if (this.appendTo) {
      const overlay = this.overlay.nativeElement;
      const appendTo = this.appendTo;
      appendTo.appendChild(overlay);
    }
  }

  close() {
    this.sidebarVisible = false;
    this.sidemenu?.destroyModal();
  }
}
